import { OmitDeep } from "type-fest";
import { ChartAxisRangeOptions } from "../../config/type/chart-axes-options";
import { ChartLegendPosition } from "../../config/type/chart-legend-options";
import { ChartOptions } from "../../config/type/chart-options";
import { createPluginOptions } from "../create-plugin-options";

const range: ChartAxisRangeOptions = {
	max: null,
	min: null,
};

const legendPosition: ChartLegendPosition = "bottom";

export const defaultSpectrumOptions = createPluginOptions<ChartOptions>()({
	axes: {
		bottom: {
			visible: true,
			grid: true,
			label: "",
			range,
		},
		left: {
			visible: true,
			grid: true,
			label: "",
			range,
			logScale: false,
		},
		right: {
			visible: false,
			grid: false,
			label: "",
			range,
			logScale: false,
		},
	},
	legend: {
		visible: true,
		position: legendPosition,
		showValue: true,
	},
});

export type SpectrumOptionsV1 = OmitDeep<
	SpectrumOptions,
	"axes.left.logScale" | "axes.right.logScale"
>;
export type SpectrumOptionsV2 = SpectrumOptions;

export type SpectrumOptions = typeof defaultSpectrumOptions;
